export var BannerNotificationTargetType;
(function (BannerNotificationTargetType) {
    BannerNotificationTargetType["USER"] = "user";
    BannerNotificationTargetType["AGENT"] = "agent";
})(BannerNotificationTargetType || (BannerNotificationTargetType = {}));
//# sourceMappingURL=BannerNotificationTargetType.js.map